export enum FieldsRequirements {
  mandatory = 1,
  required = 2,
  desired = 3,
  optional = 4,
  apiRequirement = 5,
}